/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Component, OnInit, NgZone } from '@angular/core';

import { renderQueue } from 'src/app/plain-javascript/services/RenderQueue';

import { tap } from 'rxjs/operators';
import { runInZone } from 'src/app/plain-javascript/services/rxjs-internal-extensions';
import { LoggerServiceFactory } from 'src/app/common/logging/LoggerServiceFactory';
import { DefaultLoggerService, ILoggerService } from '@touchplan/logging';

//current testing method:
// - uncomment the prefered function call in ngOnInit (only use one)

@Component({
	selector: 'app-zone-debug',
	templateUrl: './zone-debug.component.html',
	styleUrls: ['./zone-debug.component.scss'],
	providers: [LoggerServiceFactory.provide('ZoneDebugComponent')],
})
export class ZoneDebugComponent implements OnInit {
	constructor(private zone: NgZone, private logger: DefaultLoggerService) {}

	public ngOnInit() {
		// this.wrapSubscription();
		// this.wrapSubscriptionAndJumpBackIn();
		this.defaultZone();
		// this.operatorOut();

		// this.zone.onMicrotaskEmpty.subscribe(()=>{
		// 	//setting a break point here will allow you to see what triggered a microtask empty
		// 	//debugger;
		// 	this.logger.log('microtask emptied');
		// })
	}

	//attempts to leave the zone via operators do not work
	public operatorOut() {
		renderQueue.ob$
			.pipe(
				runInZone(Zone.root),
				tap(() => this.logger.log('tap zone', Zone.current.name))
			)
			.subscribe(() => {
				this.logger.log('Zone.current.name', Zone.current.name);
			});
	}

	//no microtask empty
	public wrapSubscription() {
		Zone.root.run(() => {
			renderQueue.ob$.subscribe(() => {
				// this.logger.log('Zone.current.name', Zone.current.name);
			});
		});
	}

	public wrapSubscriptionAndJumpBackIn() {
		Zone.root.run(() => {
			renderQueue.ob$.subscribe(() => {
				// this.logger.log('Zone.current.name', Zone.current.name); //root
				this.zone.run(() => {
					// this.logger.log('Zone.current.name', Zone.current.name); //angular
				});
			});
		});
	}

	//microtask empty
	public defaultZone() {
		renderQueue.ob$.subscribe(() => {
			// this.logger.log('Zone.current.name', Zone.current.name);
		});
	}
}
